export const voicebotsPath = () => "/voicebots";
export const voicebotsEditPath = (bot) => `/voicebots/${bot.id}`;
export const voicebotsNewPath = () => "/voicebots/new";
